export default "__VITE_ASSET__CNcMuO2W__"